import React from 'react';
import WorkRegisterDashboard from './WorkRegisterDashboard';

const WorkRegisterTeam = () => <WorkRegisterDashboard mode="team" />;

export default WorkRegisterTeam;
